/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * The HubSpot Contact ID for reference
 */
export type HubSpotLifecycleRequestHubspotContactId = string | null;
